export default "__VITE_ASSET__BKwvBwH4__"